<template>
    <div>
        <div class="p-4">
            <h4 class="font-bold mb-4 text-center m-auto">{{ $t("deliveryPercentagePerBranch") }}</h4>
            <div class="inputs">
                <div class="input m-1">
                <label class="font-bold">{{ $t("fromDuration") }} :</label>
                <datepicker
                    :language="ar"
                    :placeholder="$t('chooseDate')"
                    v-model="dateFrom"
                    format="dd-MM-yyyy"
                ></datepicker>
                <i>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    >
                    <g id="calendar" transform="translate(-1.987 -0.541)">
                        <rect
                        id="Rectangle_797"
                        data-name="Rectangle 797"
                        width="14"
                        height="14"
                        rx="2"
                        transform="translate(2.987 3.541)"
                        fill="none"
                        stroke="#6E6B7B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        />
                        <line
                        id="Line_395"
                        data-name="Line 395"
                        y2="4"
                        transform="translate(12.987 1.541)"
                        fill="none"
                        stroke="#6E6B7B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        />
                        <line
                        id="Line_396"
                        data-name="Line 396"
                        y2="4"
                        transform="translate(6.987 1.541)"
                        fill="none"
                        stroke="#6E6B7B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        />
                        <line
                        id="Line_397"
                        data-name="Line 397"
                        x2="14"
                        transform="translate(2.987 8.541)"
                        fill="none"
                        stroke="#6E6B7B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        />
                    </g>
                    </svg>
                </i>
                </div>
                <div class="input m-1">
                <label class="font-bold">{{ $t("toDuration") }} :</label>
                <datepicker
                    :language="ar"
                    :placeholder="$t('chooseDate')"
                    v-model="dateTo"
                    format="dd-MM-yyyy"
                ></datepicker>
                <i>
                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    >
                    <g id="calendar" transform="translate(-1.987 -0.541)">
                        <rect
                        id="Rectangle_797"
                        data-name="Rectangle 797"
                        width="14"
                        height="14"
                        rx="2"
                        transform="translate(2.987 3.541)"
                        fill="none"
                        stroke="#6E6B7B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        />
                        <line
                        id="Line_395"
                        data-name="Line 395"
                        y2="4"
                        transform="translate(12.987 1.541)"
                        fill="none"
                        stroke="#6E6B7B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        />
                        <line
                        id="Line_396"
                        data-name="Line 396"
                        y2="4"
                        transform="translate(6.987 1.541)"
                        fill="none"
                        stroke="#6E6B7B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        />
                        <line
                        id="Line_397"
                        data-name="Line 397"
                        x2="14"
                        transform="translate(2.987 8.541)"
                        fill="none"
                        stroke="#6E6B7B"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        />
                    </g>
                    </svg>
                </i>
                </div>
        </div>
            <DeliveryPercentageChart v-show="!loading"
                :limit="0" 
                :date-from="dateFromFormatted" 
                :date-to="dateToFormatted" 
                ref="chart"
            />
        </div>
        <div class="p-6 flex justify-center" v-show="loading">
            <SpinnerColor />
        </div>
    </div>

</template>

<script>
import DeliveryPercentageChart from "@/views/components/DeliveryPercentageChart.vue";
import Datepicker from "vuejs-datepicker";
import { en, ar } from "vuejs-datepicker/dist/locale";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";

export default {
    components: {
        DeliveryPercentageChart,
        Datepicker,
        SpinnerColor
    },
    data() {
        return {
            dateFrom: '',
            dateTo: '',
            dateFromFormatted: '',
            dateToFormatted: '',
            ar: ar,
            loading: true,
        }
    },
    methods: {
        async updateChart() {
            if(this.$refs.chart){
                await this.$refs.chart.fetchData();
            }
            this.loading = false;
        },
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
    },
    watch: {
        dateFrom() {
            this.dateFromFormatted = this.formatDate(this.dateFrom);
            if(!this.loading){
                this.loading = true;
                setTimeout(() => {
                    this.updateChart();
                }, 100);
            }
        },
        dateTo() {
            this.dateToFormatted = this.formatDate(this.dateTo);
            if(!this.loading){
                this.loading = true;
                setTimeout(() => {
                    this.updateChart();
                }, 100);
            }
        }
    },
    beforeMount() {
        this.loading = true;
        const today = new Date();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(today.getDate() - 30);

        this.dateFrom = thirtyDaysAgo;
        this.dateFromFormatted = this.formatDate(this.dateFrom);
        this.dateTo = today;
        this.dateToFormatted = this.formatDate(this.dateTo);
    },
    mounted() {
        this.loading = false;
    }
}
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
.inputs {
  display: flex;
  justify-content: center;
  width: 53.4375;
  margin: auto;
  margin-bottom: 1.5625rem;
  .vdp-datepicker {
    div {
      input {
        width: 25.9375rem;
        border: 0.0625rem solid #d8d6de;
        border-radius: 0.3125rem;
        height: 2.4375rem;
        padding: 0 0.75rem;
      }
      input::placeholder {
        color: #6e6b7b;
        opacity: 50%;
        font-size: 0.75rem;
        line-height: 1.3125rem;
        font-family: "cairo";
      }
    }
  }
  .input {
    position: relative;
    i {
      position: absolute;
      right: 0.75rem;
      top: 2.1rem;
      opacity: 85%;
    }
  }
}
.vdp-datepicker__calendar {
  .cell {
    border-radius: 50%;
    height: 14%;
    &:hover {
      border-color: $mainColor1 !important;
    }
  }
  .selected {
    background-color: $mainColor1;
    color: #fff;
    &:hover {
      background-color: $mainColor1;
    }
  }
}

@media (min-width: 768px) and (max-width: 1094px) {
  .inputs {
    display: block !important;
    width: 100% !important;
    .vdp-datepicker {
      div {
        input {
          width: 100% !important;
          margin-bottom: 1.125rem;
        }
      }
    }
  }
  .btn-excel {
    width: 100% !important;
  }
}

@media (min-width: 300px) and (max-width: 767px) {
  .title-page {
    h3 {
      font-size: 0.75rem !important;
    }
    .show-orders {
      font-size: 0.75rem !important;
      width: 8.125rem !important;
    }
  }
  .inputs {
    display: block !important;
    width: 100% !important;
    .vdp-datepicker {
      div {
        input {
          width: 100% !important;
          margin-bottom: 1.125rem;
        }
      }
    }
  }
  .btn-excel {
    width: 100% !important;
  }
  .body-excel {
    .text {
      padding: 0 0.9375rem !important;
      font-size: 0.875rem !important;
      margin-bottom: 0.3125rem;
    }
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";
.loader {
  border: 2px solid #fff;
  border-top: 2px solid #31006f1a;
}
.title-page {
  h3 {
    font-size: 1.125rem;
    line-height: 2.9375rem;
    color: #212121;
    font-weight: bold;
  }
}
.line {
  border-bottom: 0.03125rem solid #70707061;
  opacity: 50%;
  margin-bottom: 1.3rem;
}
.show-orders {
  cursor: pointer;
  width: 9.875rem;
  height: 2.375rem;
  background-color: $mainColor2;
  color: $mainColor1;
  font-size: 0.875rem;
  font-family: "cairo";
  line-height: 2.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}
.body-excel {
  width: fit-content;
  margin: auto;
  padding: 6px 4px;
  .excel {
    background-color: #28c76f2e;
    width: 10.4375rem;
    height: 10.4375rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.75rem auto;
    cursor: pointer;
  }
  .text {
    margin: auto;
    text-align: center;
    width: 22.75rem;
    font-family: "cairo";
    color: #6e6b7b;
    font-size: 1rem;
    line-height: 1.3125rem;
    margin-bottom: 1.5rem;
    cursor: pointer;
  }
  .inputs {
    display: flex;
    justify-content: center;
    width: 53.4375rem;
    margin: auto;
    margin-bottom: 1.5625rem;
    label {
      font-size: 0.875rem;
      color: #212121;
      line-height: 1.3125rem;
      margin-bottom: 0.4375rem;
      display: block;
      font-weight: 600;
    }
  }
  input[type="radio"] {
    display: none;
  }
  .checked,
  .unchecked {
    line-height: 0rem;
    margin-right: 0.25rem;
    cursor: pointer;
  }
  .selectDate {
    width: 100%;
    margin-bottom: 0.875rem;
    font-size: 0.875rem;
    color: #212121;
    line-height: 1.3125rem;
    font-weight: 600;
  }
}
</style>
